

export function downloadAsPlainText(textToWrite: string) {
  const textBlob = new Blob([textToWrite], { type: 'text/plain' });
  const downloadLink = document.createElement('a');
  downloadLink.href = URL.createObjectURL(textBlob);
  downloadLink.download = 'floppydata-proxies.txt';
  downloadLink.click();
  URL.revokeObjectURL(downloadLink.href);
}